//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../Validate/Validate.SelectionAndPlacementBuilder.js";
let d=[[[0,"AutomaticUpdate",1,0],[0,"ChangedFaceColor",1,0],[0,"DeviationFloor",1,0],[0,"Method",1,0],[1,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"Tolerance",1,0],[0,"UniqueFaceColor",1,0]],[],[]];
SPLM.Validate.BodyComparisonCheckBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.BodyComparisonCheckBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.BodyComparisonCheckBuilder.CheckMethod = Object.freeze({
    "Base" : "Base", "Face" : "Face", "FaceDeviation" : "FaceDeviation", "DistanceMap" : "DistanceMap"});

export default SPLM;